export default [
    {
        path: "/nomina/expediente-empleado/:idPersona/historico-contratos/:idEmpleadoPuesto",
        name: "nomina-historico-contratos",
        component: () =>
            import(
                "../index.vue"
            ),
    }
]